<template>
    <button :class="{grey: !code_flag,default:true}" type="button" @click="getPhoneCode">{{msg}}</button>
</template>

<script>
  export default {
    name: 'phone-code',
    props: {
      'mobile': {
        type: String
      },
      'url': {
        type: String
      },
      // 'type': {
      //   type: String
      // }
    },
    data() {
      return {
        msg: '获取验证码',
        count_time: 60,
        code_flag: true,
        loop: {}
      }
    },
    methods: {
      getPhoneCode: function () {
        if (this.code_flag) {
          if (!this.mobile) {
            alert('请输入手机号')
            return true
          }
          let phone = /^((13|14|15|17|18)[0-9]{1}\d{8})$/
          if (!phone.test(this.mobile)) {
            alert('您输入的手机号码不正确，请重新输入！')
            return true
          }
          let url = this.url
          this.$post(url, {mobile: this.mobile}).then((res) => {
            if (res.code === 0) {
              this.countDown()
            }
          })
        }
      },
      countDown: function () {
        this.code_flag = false
        this.msg = `重新获取(${this.count_time})`
        let t = setInterval(() => {
          if (this.count_time > 0) {
            this.count_time--
            this.msg = `重新获取(${this.count_time})`
          } else {
            this.msg = '获取验证码'
            this.count_time = this.count_time
            this.code_flag = true
            window.clearInterval(t)
          }
        }, 1000)
      }
    }
  }
</script>

<style scoped>
    .grey {
        color: #999 !important;
    }

    .default {
        width: 115px;
        text-align: center;
        background: white;
        color: #24357b;
        border: 1px solid #DCDFE6;
        padding: 10px;
    }
</style>
